'use strict';

function isLeftClickEvent(e) {
  return e.button === 0;
}

function isModifiedEvent(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}

function shouldHandleClick(e) {
  var target = e.target.getAttribute('target');
  return !target && !isModifiedEvent(e) && isLeftClickEvent(e);
}

module.exports = shouldHandleClick;


/** WEBPACK FOOTER **
 ** ./utils/shouldHandleClick.js
 **/